module.exports = "/assets/data/a6f1b10bc5a9b26db5a0f5cd62af19f7-WD7.data.json";